import { render } from "./ListProjects.vue?vue&type=template&id=3e63e3e4"
import script from "./ListProjects.vue?vue&type=script&lang=js"
export * from "./ListProjects.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__